// Give a filename a " (2)", " (3)"… suffix before its extension until it no
// longer clashes with a name already taken.
export function uniqueName(filename, taken) {
  if (!taken.has(filename)) return filename

  const dot = filename.lastIndexOf(".")
  const base = dot > 0 ? filename.slice(0, dot) : filename
  const extension = dot > 0 ? filename.slice(dot) : ""
  let count = 2
  while (taken.has(`${base} (${count})${extension}`)) count++
  return `${base} (${count})${extension}`
}

// Pair each file's name with its contents for fflate, renaming duplicates so
// no file overwrites another in the zip.
export function zipEntries(files, contents) {
  const taken = new Set()
  const entries = {}

  files.forEach(({ filename }, index) => {
    const name = uniqueName(filename, taken)
    taken.add(name)
    entries[name] = contents[index]
  })

  return entries
}
